import { Box } from '@mui/material'
import React from 'react'

const vision: any = [
    {
        title: "Corporate Mission",
        body: "As a business entity, we optimize our service quality, cost effectiveness and profitability in all our activities along the stakeholders value chain. As a State-linked corporation, we contribute to the well being of the State's socio-economic development."
    },
    {
        title: "Mission statement",
        body: "M/S Karnafully International intends to Bethe best creative idea planner and executor providing one stop services in terms of Clearing & Forwarding Service through ensuring the proper combination of time (meeting the deadline), quality(maximum output) and cost."
    },
    {
        title: "We believe on times",
        body: " A corporate strength lies in the spirit of an experienced team. Teamwork should be the principal condition of the success.Apply the sense of creativity along with the technical implications.We visualize the concepts that may be deemed effective to communicate the message of the client's products and services."
    },
    {
        title: "Values",
        body: "Values are an important part of the cement that holds together the foundation of our business. Our vision is strongly supported by our shared core values, which create and sustain the success of our team."
    },
    {
        title: "Corporate Vision",
        body: "To become prominent diversified entity through excellence in our core businesses."
    },
    {
        title: "Customer focus",
        body: "We try to meet and exceed customers demands by delivering what we promise."
    },
    {
        title: "Honesty and Integrity",
        body: "Honesty and Integrity together form the foundation our trust. The success of our organization stems from the open and honest approach of our people."
    },
    {
        title: "Trust",
        body: "Trust in our company is built by people sharing a common purpose and culture and basing their priorities on the needs of our clients and the business itself."
    },
    {
        title: "Knowledge-sharing culture",
        body: "We focus on companywide knowledge-sharing platforms, consisting of a wide range of information-exchange tools and techniques thus trying to create a truly knowledge-sharing corporate culture."
    },
    {
        title: "Collaborative teamwork",
        body: "Collaborative teamwork is more than ever becoming the most strategic capability for any firm and is one of our company's mantras for business success."
    },
    {
        title: "Commitment to excellence",
        body: "Commitment to excellence is built when we are trusted and are able to trust our colleagues in every minor detail."
    },
    {
        title: "Services We Rendered",
        body: "Promotional Custom Clearing & Forwarding Service."
    },
]












function Vision() {
    return (

        <Box>
            <div id='vision'>
                <h5 className='text-center fw-bold mb-5 f-upper pt-3'>Mission, Vision & Values :</h5>

                <div className="row">
                    {vision.map((item: any, i: any) => {
                        return <div className="col-lg-6" key={i}>
                            <div className="c_details pt-2 ps-5">
                                <strong><li>{item.title}:</li></strong>
                                <p>{item.body}</p>
                            </div>
                        </div>
                    })}
                </div>
            </div>
        </Box>


    )
}

export default Vision